export default __webpack_public_path__ + "static/media/481.dc0a0d99.gif";